import { createSlice } from '@reduxjs/toolkit'
import { useCookies } from 'react-cookie'


export const mainSlice = createSlice({
  name: 'main',
  initialState: {
    ismember:null,
    biz:[]
   
  },
  reducers: {
    
    setIsMemberRedux: (state, action) => {
        const { ismember } = action.payload
        state.ismember = ismember
      },
      setBizRedux: (state, action) => {
        const { biz } = action.payload
        state.biz = biz
      }
      
  },
})

export default mainSlice.reducer;

export const {
    setIsMemberRedux,
    setBizRedux
   
  
} = mainSlice.actions

export const getIsMemberRedux = (state) => state.main.ismember
export const getBizRedux = (state) => state.main.biz



